// extracted by mini-css-extract-plugin
module.exports = {"form-group":"CheckBox_form-group__1a9Jz","label-wrapper":"CheckBox_label-wrapper__Jox_I"};